function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 195.71,
    height: 195.71,
    viewBox: "0 0 195.71 195.71",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M100,197.85A97.85,97.85,0,1,1,197.85,100,98,98,0,0,1,100,197.85Zm0-185.7A87.85,87.85,0,1,0,187.85,100,88,88,0,0,0,100,12.15Z",
    transform: "translate(-2.15 -2.15)",
    style: {
      fill: "#ed2024"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 69.49,
    cy: 71.74,
    rx: 13.49,
    ry: 17.34,
    style: {
      fill: "#ed2024"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 124.42,
    cy: 71.74,
    rx: 13.49,
    ry: 17.34,
    style: {
      fill: "#ed2024"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100,110h-.2c-41.4.13-58.85,43.16-59.58,45l8.29,3.27c.16-.39,16-39.29,51.39-39.36s51.23,39,51.39,39.36l8.29-3.27c-.73-1.84-18.18-44.87-59.58-45Z",
    transform: "translate(-2.15 -2.15)",
    style: {
      fill: "#ed2024"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSad);
export default __webpack_public_path__ + "static/media/sad.4d3a50b9ce88b11ba04b4b26e98151c9.svg";
export { ForwardRef as ReactComponent };